import { apiClient } from "@base/api/client";
import type { AdminStatus } from "@features/admin/model/types";

/**
 * GET /82office/membership/api/admin
 * 관리자 권한 확인
 */
export async function fetchAdminStatus(): Promise<AdminStatus> {
  const { data } = await apiClient.get<AdminStatus>("/82office/membership/api/admin");
  return data;
}
